App.controller('ZochInsuranceDetailsCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Szczegóły deklaracje';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.insurance.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.insurance.list');
    }

    if ($scope.data.partner && Object.keys($scope.data.partner).length) {
        $scope.partner_length = true;
    }

    if ($scope.data.children.length) {
        $scope.children_length = true;
    }

    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var id = value.id, barcode = value.barcode;
        zochaInsuranceService.getDeclaration(barcode).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.getStatement = function(ev, data) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        zochaInsuranceService.getStatement(data.barcode).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'oswiadczenie.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.reason = 'EMPLOYEE_RESIGNATION';

    $scope.withdraw = function(id) {
        var criteria = {
            id: id,
            data: {
                withdrawalReason: $scope.reason
            }
        };

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $scope.dateOfDeath
        }

        zochaInsuranceService.withdraw(criteria).then(function (data) {
            if (data.status === 200) {
                $state.go('root.home.zoch.insurance.list');
            }
        });
    }
}]);
